// translationsClient.ts
export type TranslationsResponse = {
    locale: string;
    namespace: string;
    items: Record<string, string>;
};

export async function fetchTranslations(opts: {
    baseUrl: string;
    locale: string;
    namespace: string;
    signal?: AbortSignal;
}): Promise<TranslationsResponse> {
    const { baseUrl, locale, namespace, signal } = opts;

    // Build URL (baseUrl may be empty if same-origin)
    const u = new URL(
        `/api/translations?locale=${encodeURIComponent(locale)}&namespace=${encodeURIComponent(namespace)}`,
        baseUrl || window.location.origin
    );

    const res = await fetch(u.toString(), {
        method: "GET",
        credentials: "include", // fine even if public (cookies ignored if none)
        headers: { "Accept": "application/json" },
        signal
    });

    if (!res.ok) {
        // Surface a readable error for console
        const text = await res.text().catch(() => "");
        throw new Error(`Translations fetch failed (${res.status}): ${text || res.statusText}`);
    }

    const json = (await res.json()) as TranslationsResponse;

    // Basic shape validation
    if (!json || typeof json !== "object" || !json.items || typeof json.items !== "object") {
        throw new Error("Invalid translations payload");
    }

    return json;
}